export default __webpack_public_path__ + "static/media/annoucement.13831701.webp";